import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { N } from '@fullcalendar/core/internal-common';
export interface Legend {
  value: number,
  label: string
}
@Component({
  selector: 'split-legend-revenue',
  templateUrl: './split-legend-revenue.component.html',
  styleUrls: ['./split-legend-revenue.component.scss']
})
export class SplitLegendRevenueComponent implements OnChanges {

  @Input() previous: number  = 0;
  @Input() currency: number = 0;

  @Input() date = new Date();

  previousDate = new Date(this.date.getFullYear(), this.date.getMonth() - 1, 1);


  ngOnChanges(changes: SimpleChanges): void {
    if(changes['date']) this.previousDate = new Date(this.date.getFullYear(), this.date.getMonth() - 1, 1);
  }

}
